import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

export function TermsOfService() {
  return (
    <div className="legal-page" data-testid="terms-of-service-page">
      <div className="legal-container">
        <Link to="/" className="legal-back-link" data-testid="back-link">
          <ArrowLeft size={18} />
          <span>Back</span>
        </Link>

        <div className="legal-header">
          <div className="legal-icon">
            <FileText size={24} />
          </div>
          <h1>Terms of Service</h1>
          <p className="legal-updated">Last updated: January 2026</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Agreement to Terms</h2>
            <p>
              By accessing or using TradeLife ("Service"), you agree to be bound by these Terms of Service. 
              TradeLife is a software platform that provides business management tools for tradespeople. 
              If you disagree with any part of these Terms, you may not access the Service.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Description of Service</h2>
            <p>
              TradeLife provides software tools to help manage your trade business, including:
            </p>
            <ul>
              <li>Job management and tracking</li>
              <li>Estimate, quote, and invoice creation</li>
              <li>Financial management tools</li>
              <li>AI-assisted features for business operations</li>
              <li>Communication and scheduling tools</li>
              <li>Emergency escalation features</li>
            </ul>
            <p>
              <strong>Important:</strong> TradeLife provides software tools only. We do not provide trade services, 
              financial advice, legal advice, or any professional services beyond the software platform itself.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. User Responsibilities</h2>
            <p>
              As a user of TradeLife, you remain fully responsible for:
            </p>
            <ul>
              <li>All pricing decisions for your quotes, estimates, and invoices</li>
              <li>Defining and delivering the scope of work to your clients</li>
              <li>Setting and meeting timelines for your projects</li>
              <li>Ensuring compliance with all applicable health, safety, and building regulations</li>
              <li>Maintaining appropriate insurance and certifications for your trade</li>
              <li>The accuracy of all information entered into the system</li>
              <li>All communications with your clients</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Account Registration</h2>
            <p>
              To use certain features, you must register for an account. You agree to:
            </p>
            <ul>
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Notify us immediately of any unauthorised access</li>
              <li>Accept responsibility for all activities under your account</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Subscription and Billing</h2>
            <p>
              Access to certain features requires a paid subscription. Subscription terms, pricing, and features 
              are described on our pricing page. Payments are processed through secure third-party providers. 
              Subscriptions renew automatically unless cancelled.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Intellectual Property</h2>
            <p>
              TradeLife and its content, features, and functionality are owned by us and protected by 
              intellectual property laws. You retain ownership of content you create. By using the Service, 
              you grant us a licence to use, store, and display your content as necessary to provide the Service.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law:
            </p>
            <ul>
              <li>The Service is provided "as is" without warranties of any kind</li>
              <li>We are not liable for indirect, incidental, or consequential damages</li>
              <li>We are not responsible for outcomes resulting from use of our tools</li>
              <li>Our total liability shall not exceed the amount paid by you in the last 12 months</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>8. Service Modifications</h2>
            <p>
              We reserve the right to modify or discontinue features at any time, update pricing with reasonable 
              notice, and change these Terms. Significant changes will be communicated to you.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Termination</h2>
            <p>
              We may suspend or terminate your access if you violate these Terms, fail to pay subscription fees, 
              or engage in fraudulent or illegal activity. Upon termination, your right to use the Service ceases immediately.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Governing Law</h2>
            <p>
              These Terms shall be governed by the laws of England and Wales. Any disputes shall be resolved 
              in the courts of England and Wales.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Contact Information</h2>
            <p>
              For questions about these Terms, please contact us at:
            </p>
            <p className="legal-contact">
              <strong>Email:</strong> legal@tradelife.app<br />
              <strong>Support:</strong> support@tradelife.app
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;
